import { Notification, Message } from "element-ui";
import axios from "axios";
import router from "@/router";
import { clearLoginInfo } from "@/utils/auth";
import qs from "querystring";

// 创建实例
export function createInstance() {
  let baseURL = "";
  if (process.env.VUE_APP_API_ENDPOINT) {
    baseURL = process.env.VUE_APP_API_ENDPOINT;
  } else {
    // 本地
    baseURL = "/api";
  }
  return axios.create({
    baseURL,
    paramsSerializer: function (params) {
      return qs.stringify(params);
    },
    withCredentials: false,
  });
}
const instance = createInstance();

// 请求拦截
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

// 响应拦截
instance.interceptors.response.use(
  response => {
    const { data, headers } = response;
    // 处理文件流
    if (headers["content-type"]?.includes("application/octet-stream")) {
      return response;
    }
    // 统一处理业务状态码
    if (data) {
      if (data.code && data.code !== 200) {
        const errorMsg = data.msg || data.subMsg || "Unknown Error";
        Message.error(errorMsg);
        return Promise.reject(data);
      } else {
        // 直接返回数据主体
        return data;
      }
    } else {
      return Promise.reject("error: Request to return no data");
    }
  },
  error => {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      const errorMsg = data?.msg || data?.message || "Network request exception";

      switch (status) {
        case 401:
          clearLoginInfo();
          // 避免重复跳转
          if (router.currentRoute.name !== "login") {
            router.push({ name: "login" });
          }
          break;
        case 403:
          Notification.error({ title: "Insufficient permissions", message: "You do not have access permission" });
          break;
        case 500:
          Message.error("Internal server error");
          break;
        default:
          Message.error(errorMsg);
      }
    } else {
      // 处理断网或超时
      if (error.message.includes("timeout")) {
        Message.error("Request timed out, please try again later");
      } else {
        Message.error("Unable to connect to the server, please check the network");
      }
    }

    return Promise.reject(error);
  },
);

// 封装常用方法
instance.postForm = (url, body) => {
  return instance.post(url, qs.stringify(body), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

instance.postFormData = (url, formData) => {
  return instance.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export default instance;
